import "core-js/modules/es.array.push.js";
import { CdrText as z, CdrButton as B, CdrRating as K, IconPlusLg as V, CdrModal as j, IconHeartStroke as F, IconXLg as D, IconArrowLeft as $, IconArrowRight as H, IconExperiencesCycling as W, CdrGrid as X, CdrImg as J } from "@rei/cedar";
import { CompassSpinner as Q } from "@rei/spinner";
import { CdrBreakpointLg as Y, CdrBreakpointMd as Z, CdrBreakpointSm as ee } from "@rei/cdr-tokens";
import G from "@rei/landing-image-component";
import { resolveComponent as r, openBlock as d, createElementBlock as f, createVNode as s, withCtx as l, createTextVNode as y, toDisplayString as g, createElementVNode as m, createBlock as x, normalizeClass as N, normalizeStyle as te, createCommentVNode as v, Fragment as E, renderList as q, withDirectives as k, vShow as L, withModifiers as oe, mergeProps as ne } from "vue";
const S = (e, o) => {
  const t = e.__vccOpts || e;
  for (const [c, i] of o)
    t[c] = i;
  return t;
}, ae = {
  name: "UgcProduct",
  components: {
    CdrText: z,
    CdrButton: B,
    CdrRating: K,
    LandingImageComponent: G
  },
  props: {
    product: {
      type: Object,
      required: !1,
      default: () => ({})
    }
  },
  computed: {
    brand() {
      var e;
      return (e = this.product) == null ? void 0 : e.brand;
    },
    name() {
      var e;
      return (e = this.product) == null ? void 0 : e.name;
    },
    media() {
      var c, i, n;
      const e = (c = this.product) == null ? void 0 : c.media.alt, o = (i = this.product) == null ? void 0 : i.media.small, t = ((n = this.product) == null ? void 0 : n.media.medium) || o;
      return {
        alt: e,
        xs: o,
        sm: t
      };
    },
    price() {
      var e;
      return `$${(e = this.product) == null ? void 0 : e.price}`;
    },
    cta() {
      var e;
      return (e = this.product) == null ? void 0 : e.link;
    },
    rating() {
      var t, c, i, n, _, u, h, C;
      const e = (c = (t = this.product) == null ? void 0 : t.reviews) != null && c.count ? (n = (i = this.product) == null ? void 0 : i.reviews) == null ? void 0 : n.count : 0, o = (u = (_ = this.product) == null ? void 0 : _.reviews) != null && u.rating ? (C = (h = this.product) == null ? void 0 : h.reviews) == null ? void 0 : C.rating : 0;
      return {
        count: e,
        rating: o
      };
    }
  }
}, re = {
  class: "ugc-product__inner"
}, se = {
  class: "ugc-product__img",
  "data-ui": "ugc-product-img"
};
function ie(e, o, t, c, i, n) {
  const _ = r("cdr-text"), u = r("cdr-rating"), h = r("landing-image-component"), C = r("cdr-button");
  return d(), f("div", re, [s(_, {
    class: "ugc-product__brand",
    "data-ui": "ugc-product-brand"
  }, {
    default: l(() => [y(g(n.brand), 1)]),
    _: 1
  }), s(_, {
    tag: "h2",
    class: "ugc-product__name",
    "data-ui": "ugc-product-name"
  }, {
    default: l(() => [y(g(n.name), 1)]),
    _: 1
  }), s(u, {
    class: "ugc-product__rating",
    rating: n.rating.rating,
    count: n.rating.count,
    size: "small",
    "data-ui": "ugc-produtc-rating"
  }, null, 8, ["rating", "count"]), m("div", se, [s(h, {
    media: n.media,
    "lazy-load": !1
  }, null, 8, ["media"])]), s(_, {
    class: "ugc-product__price",
    "data-ui": "ugc-product-price"
  }, {
    default: l(() => [y(g(n.price), 1)]),
    _: 1
  }), s(C, {
    class: "ugc-product__cta",
    modifier: "secondary",
    tag: "a",
    href: n.cta,
    "data-ui": "ugc-product-cta"
  }, {
    default: l(() => [y(" Shop this product ")]),
    _: 1
  }, 8, ["href"])]);
}
const ce = /* @__PURE__ */ S(ae, [["render", ie]]);
const de = {
  name: "ImageBeacon",
  components: {
    CdrButton: B,
    IconPlusLg: V
  },
  props: {
    buttonStyle: {
      type: Object,
      required: !0,
      default: () => {
      }
    },
    iconClass: {
      type: String,
      required: !1,
      default: ""
    },
    isActive: {
      type: Boolean,
      required: !1,
      default: !1
    },
    buttonText: {
      type: String,
      required: !0,
      default: ""
    },
    productId: {
      type: String,
      required: !0,
      default: ""
    }
  },
  emits: ["imageBeaconClick"],
  computed: {
    getIconClass() {
      return this.iconClass ? `${this.iconClass}` : "";
    },
    formattedAriaLabel() {
      return `Open details for ${this.buttonText}`;
    }
  }
};
function le(e, o, t, c, i, n) {
  const _ = r("icon-plus-lg"), u = r("cdr-button");
  return d(), x(u, {
    class: N(`beacon ${t.isActive ? "active" : ""}`),
    style: te(t.buttonStyle),
    "icon-only": !0,
    "aria-label": n.formattedAriaLabel,
    "data-analytics-id": n.formattedAriaLabel,
    "aria-current": t.isActive,
    "aria-haspopup": "dialog",
    onClick: o[0] || (o[0] = (h) => e.$emit("imageBeaconClick", t.productId))
  }, {
    icon: l(() => [s(_, {
      class: N(`beacon__button-inner ${n.getIconClass}`)
    }, null, 8, ["class"])]),
    _: 1
  }, 8, ["class", "style", "aria-label", "data-analytics-id", "aria-current"]);
}
const ue = /* @__PURE__ */ S(de, [["render", le]]);
const _e = "ArrowLeft", me = "ArrowRight", ge = {
  name: "UgcModal",
  components: {
    CdrText: z,
    CdrModal: j,
    IconHeartStroke: F,
    CdrButton: B,
    IconXLg: D,
    IconArrowLeft: $,
    IconArrowRight: H,
    LandingImageComponent: G,
    IconExperiencesCycling: W,
    UgcProduct: ce,
    ImageBeacon: ue
  },
  props: {
    isModalOpened: {
      type: Boolean,
      required: !0,
      default: !1
    },
    content: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    hasNext: {
      type: Boolean,
      required: !0,
      default: !1
    },
    hasPrevious: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isLoadingNextPage: {
      type: Boolean,
      required: !1,
      default: !1
    },
    hideProductArea: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["onCloseModal", "onPreviousItem", "onNextItem"],
  data() {
    return {
      activeProduct: ""
    };
  },
  computed: {
    username() {
      var o, t;
      return (o = this.content) != null && o.username ? `@${(t = this.content) == null ? void 0 : t.username}` : "";
    },
    products() {
      var e;
      return (e = this.content) == null ? void 0 : e.products;
    },
    media() {
      var t, c;
      const e = (t = this.content) == null ? void 0 : t.media.alt, o = (c = this.content) == null ? void 0 : c.media.large;
      return {
        alt: e,
        xs: o
      };
    },
    showProductArea() {
      var e;
      return ((e = this.products) == null ? void 0 : e.length) && !this.hideProductArea;
    }
  },
  mounted() {
    document.addEventListener("keydown", this.handleKeydown);
  },
  unmounted() {
    document.removeEventListener("keydown", this.handleKeydown);
  },
  updated() {
    this.isModalOpened && this.setActiveUgcProduct(this.products ? this.products[0].productId : null);
  },
  methods: {
    handleKeydown(e) {
      if (this.isLoadingNextPage)
        return !1;
      const o = e.key;
      return o === _e && this.hasPrevious ? this.$emit("onPreviousItem", !1) : o === me && this.hasNext && this.$emit("onNextItem", !1), !1;
    },
    formatCoordinates(e) {
      return e ? {
        "--beacon-left": `${100 * e.x}%`,
        "--beacon-top": `${100 * e.y}%`
      } : {};
    },
    setActiveUgcProduct(e) {
      this.activeProduct = e;
    }
  }
}, he = {
  class: "ugc-modal__inner"
}, pe = {
  class: "ugc-modal__description-container"
}, fe = {
  key: 1,
  class: "ugc-modal__likecount",
  "data-ui": "ugc-modal-like-count"
}, ye = /* @__PURE__ */ m("span", {
  class: "sr-only"
}, " likes", -1), Ce = {
  class: "ugc-modal__image"
}, ve = {
  key: 0,
  class: "ugc-modal__product"
};
function xe(e, o, t, c, i, n) {
  const _ = r("icon-x-lg"), u = r("cdr-button"), h = r("cdr-text"), C = r("icon-heart-stroke"), T = r("icon-arrow-left"), O = r("landing-image-component"), b = r("image-beacon"), a = r("ugc-product"), w = r("icon-experiences-cycling"), M = r("icon-arrow-right"), P = r("cdr-modal");
  return d(), x(P, {
    opened: t.isModalOpened,
    label: "",
    "show-title": !1,
    "data-ui": "ugc-gallery-open-modal",
    "wrapper-class": "ugc-modal__wrapper",
    onClosed: o[3] || (o[3] = () => e.$emit("onCloseModal", !1))
  }, {
    modal: l(() => {
      var I, U, R;
      return [m("div", he, [s(u, {
        class: "ugc-modal__button ugc-modal__button-close",
        "aria-label": "Close",
        "icon-only": "",
        onClick: o[0] || (o[0] = (p) => {
          e.$emit("onCloseModal", !1);
        })
      }, {
        icon: l(() => [s(_)]),
        _: 1
      }), s(h, {
        class: "ugc-modal__username",
        "data-ui": "ugc-modal-username"
      }, {
        default: l(() => [y(g(n.username), 1)]),
        _: 1
      }), m("div", pe, [(I = t.content) != null && I.relativeTime ? (d(), x(h, {
        key: 0,
        class: "ugc-modal__relativeTime",
        "data-ui": "ugc-modal-relative-time"
      }, {
        default: l(() => [y(g(t.content.relativeTime), 1)]),
        _: 1
      })) : v("", !0), ((U = t.content) == null ? void 0 : U.likeCount) > 0 ? (d(), f("div", fe, [s(C, {
        "inherit-color": "",
        size: "small"
      }), y(" " + g((R = t.content) == null ? void 0 : R.likeCount) + " ", 1), ye])) : v("", !0)]), t.content ? (d(), f("div", {
        key: 0,
        class: N(["ugc-modal__content", {
          "ugc-modal__content--hide-product-area": t.hideProductArea
        }])
      }, [s(u, {
        class: "ugc-modal__button ugc-modal__arrow ugc-modal__arrow-left",
        "aria-label": "Previous Slide",
        "data-analytics-id": "Previous Slide",
        "icon-only": "",
        "with-background": "",
        disabled: !t.hasPrevious,
        "data-ui": "ugc-modal-button-left",
        onClick: o[1] || (o[1] = (p) => {
          e.$emit("onPreviousItem", !1);
        })
      }, {
        icon: l(() => [s(T)]),
        _: 1
      }, 8, ["disabled"]), m("div", Ce, [s(O, {
        media: n.media,
        "lazy-load": !1,
        "data-ui": "ugc-modal-image"
      }, null, 8, ["media"]), n.showProductArea ? (d(!0), f(E, {
        key: 0
      }, q(n.products, (p, A) => (d(), x(b, {
        key: `beacon-${A}`,
        "product-id": p.productId,
        "button-text": p.name,
        "button-style": n.formatCoordinates(p.spatialTagInfo),
        "is-active": i.activeProduct === p.productId,
        onImageBeaconClick: n.setActiveUgcProduct
      }, null, 8, ["product-id", "button-text", "button-style", "is-active", "onImageBeaconClick"]))), 128)) : v("", !0)]), n.showProductArea ? (d(), f("div", ve, [(d(!0), f(E, null, q(n.products, (p, A) => k((d(), x(a, {
        key: `ugcModalProduct-${A}`,
        product: p
      }, null, 8, ["product"])), [[L, i.activeProduct === p.productId]])), 128))])) : v("", !0), s(u, {
        class: N(["ugc-modal__button ugc-modal__arrow ugc-modal__arrow-right", {
          "is-loading": t.isLoadingNextPage
        }]),
        "aria-label": "Next Slide",
        "data-analytics-id": "Next Slide",
        "icon-only": "",
        "with-background": "",
        disabled: !t.hasNext || t.isLoadingNextPage,
        "data-ui": "ugc-modal-button-right",
        onClick: o[2] || (o[2] = (p) => {
          e.$emit("onNextItem", !1);
        })
      }, {
        icon: l(() => [k(s(w, {
          "data-ui": "icon-experiences-cycling"
        }, null, 512), [[L, t.isLoadingNextPage]]), k(s(M, null, null, 512), [[L, !t.isLoadingNextPage]])]),
        _: 1
      }, 8, ["class", "disabled"])], 2)) : v("", !0)])];
    }),
    _: 1
  }, 8, ["opened"]);
}
const Ie = /* @__PURE__ */ S(ge, [["render", xe]]);
const be = "Space", we = "Enter", Me = {
  name: "UgcGallery",
  components: {
    CdrGrid: X,
    CdrButton: B,
    CdrImg: J,
    IconHeartStroke: F,
    CompassSpinner: Q,
    UgcModal: Ie
  },
  props: {
    items: {
      type: Array,
      required: !1,
      default: () => []
    },
    config: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    error: {
      type: Boolean,
      required: !1,
      default: !1
    },
    loading: {
      type: Boolean,
      required: !1,
      default: !1
    },
    hasMoreToLoad: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["onLoadMore"],
  data() {
    return {
      isModalOpened: !1,
      modalContent: null,
      itemCache: [],
      itemsToShow: [],
      currentItemIndex: 0,
      isEnterPress: !1
    };
  },
  computed: {
    itemsPerPage() {
      const e = (o) => {
        var t;
        return (t = window == null ? void 0 : window.matchMedia(`(min-width: ${o}px)`)) == null ? void 0 : t.matches;
      };
      return e(Y) ? {
        initial: 10,
        loadMore: 10
      } : e(Z) ? {
        initial: 8,
        loadMore: 8
      } : e(ee) ? {
        initial: 6,
        loadMore: 6
      } : {
        initial: 1,
        loadMore: 2
      };
    },
    shownCount() {
      return this.itemsToShow.length;
    },
    totalCount() {
      return this.itemCache.length;
    },
    loadMoreCount() {
      return this.itemsPerPage.loadMore;
    },
    loadMoreButton() {
      const {
        loadMoreButton: {
          text: e,
          textError: o,
          props: t,
          props: {
            modifier: c
          } = {}
        } = {}
      } = this.config || {};
      return {
        text: this.error ? o || "Loading error" : e || "Load More",
        props: {
          ...t,
          modifier: c || "secondary"
        }
      };
    },
    renderLoadMoreButton() {
      return this.hasMoreToLoad || this.totalCount > this.shownCount;
    },
    openModalButton() {
      const {
        openModalButton: e
      } = this.config || {};
      return {
        text: (e == null ? void 0 : e.text) || "Shop now"
      };
    }
  },
  watch: {
    items: {
      deep: !0,
      handler() {
        this.handleNextPage(), this.isModalOpened && this.onNextItem();
      }
    }
  },
  mounted() {
    document.addEventListener("keydown", this.handleKeydown), this.itemCache = this.items, this.itemsToShow = this.itemCache.slice(0, this.itemsPerPage.initial);
  },
  methods: {
    handleModalOpen(e) {
      this.modalContent = this.itemsToShow.find((o, t) => o.id === e ? (this.currentItemIndex = t, !0) : !1), this.isModalOpened = !0;
    },
    isLastItem() {
      return this.currentItemIndex === this.itemsToShow.length - 1;
    },
    onModalClose(e) {
      this.isModalOpened = e, this.modalContent = null;
    },
    setModalContentFromIndex() {
      this.modalContent = this.itemsToShow[this.currentItemIndex];
    },
    onPreviousItem() {
      this.currentItemIndex -= 1, this.setModalContentFromIndex();
    },
    onNextItem() {
      if (this.isLastItem() && this.hasMoreToLoad) {
        this.handleLoadMore();
        return;
      }
      this.currentItemIndex += 1, this.setModalContentFromIndex();
    },
    handleNextPage() {
      const e = this.itemsToShow.length, o = this.itemCache.slice(this.shownCount, this.shownCount + this.loadMoreCount);
      this.itemsToShow.push(...o), this.focusNextItem(e);
    },
    handleLoadMore() {
      const e = this.totalCount - this.shownCount > this.loadMoreCount, o = !this.hasMoreToLoad && this.totalCount > this.shownCount;
      if (e || o) {
        this.handleNextPage(), this.isModalOpened && this.onNextItem();
        return;
      }
      this.$emit("onLoadMore");
    },
    handleKeydown(e) {
      const o = e.code;
      (o === be || o === we) && (this.isEnterPress = !0);
    },
    focusNextItem(e) {
      this.isEnterPress && this.$nextTick(() => {
        this.$refs[`ugc-gallery-item-${e}`][0].$el.focus(), this.isEnterPress = !1;
      });
    }
  }
}, Pe = {
  class: "ugc-gallery",
  "data-ui": "ugc-gallery"
}, ke = {
  class: "ugc-gallery__item-overlay"
}, Le = {
  class: "sr-only"
}, Ne = {
  class: "ugc-gallery__item-overlay-meta"
}, Be = {
  class: "ugc-gallery__item-overlay-meta-content"
}, Se = {
  key: 0
}, Te = /* @__PURE__ */ m("span", {
  class: "sr-only"
}, " likes", -1), Oe = {
  class: "ugc-gallery__load-more-wrapper"
};
function Ae(e, o, t, c, i, n) {
  var b;
  const _ = r("cdr-img"), u = r("cdr-button"), h = r("icon-heart-stroke"), C = r("cdr-grid"), T = r("compass-spinner"), O = r("ugc-modal");
  return d(), f("div", Pe, [s(C, {
    class: "ugc-gallery__grid",
    tag: "ul"
  }, {
    default: l(() => [(d(!0), f(E, null, q(i.itemsToShow, (a, w) => {
      var M, P;
      return d(), f("li", {
        key: w,
        class: "ugc-gallery__item"
      }, [s(_, {
        class: "ugc-gallery__item-image",
        src: (M = a == null ? void 0 : a.media) == null ? void 0 : M.large,
        alt: (P = a == null ? void 0 : a.media) == null ? void 0 : P.alt,
        cover: "",
        loading: "lazy"
      }, null, 8, ["src", "alt"]), m("div", ke, [s(u, {
        ref_for: !0,
        ref: `ugc-gallery-item-${w}`,
        class: "ugc-gallery__item-button",
        "aria-haspopup": "dialog",
        "data-ui": "ugc-gallery-open-modal",
        onClick: oe(() => n.handleModalOpen(a == null ? void 0 : a.id), ["prevent"])
      }, {
        default: l(() => {
          var I;
          return [m("span", Le, g(`${(I = a == null ? void 0 : a.media) == null ? void 0 : I.alt} `), 1), y(" " + g(n.openModalButton.text), 1)];
        }),
        _: 2
      }, 1032, ["onClick"]), m("div", Ne, [m("div", Be, [m("div", null, "@" + g(a == null ? void 0 : a.username), 1), (a == null ? void 0 : a.likeCount) > 0 ? (d(), f("div", Se, [s(h, {
        "inherit-color": "",
        size: "small"
      }), y(" " + g(a == null ? void 0 : a.likeCount) + " ", 1), Te])) : v("", !0)])])])]);
    }), 128))]),
    _: 1
  }), k(s(T, {
    class: "ugc-gallery__spinner",
    role: "alert",
    "aria-label": "Loading more",
    "aria-live": "polite"
  }, null, 512), [[L, t.loading]]), m("div", Oe, [n.renderLoadMoreButton ? (d(), x(u, ne({
    key: 0,
    class: "ugc-gallery__load-more",
    "data-ui": "ugc-gallery-load-more"
  }, n.loadMoreButton.props, {
    disabled: t.loading || t.error,
    onClick: n.handleLoadMore
  }), {
    default: l(() => [y(g(n.loadMoreButton.text), 1)]),
    _: 1
  }, 16, ["disabled", "onClick"])) : v("", !0)]), s(O, {
    "is-modal-opened": i.isModalOpened,
    content: i.modalContent,
    "is-loading-next-page": t.loading,
    "has-next": t.hasMoreToLoad || !n.isLastItem(),
    "has-previous": i.currentItemIndex !== 0,
    "hide-product-area": (b = t.config) == null ? void 0 : b.hideProductArea,
    onOnCloseModal: n.onModalClose,
    onOnPreviousItem: n.onPreviousItem,
    onOnNextItem: n.onNextItem
  }, null, 8, ["is-modal-opened", "content", "is-loading-next-page", "has-next", "has-previous", "hide-product-area", "onOnCloseModal", "onOnPreviousItem", "onOnNextItem"])]);
}
const Ge = /* @__PURE__ */ S(Me, [["render", Ae]]);
export {
  Ge as default
};
